import {Text} from '@chakra-ui/react';
import {AlertDialog} from 'components/shared';
import {useTranslation} from 'hooks';
import {useRouter} from 'next/router';
import {FC} from 'react';

interface IProps {
  onConfirm: () => void;
}

export const AlertAdultProducts: FC<IProps> = ({onConfirm}) => {
  const {t} = useTranslation();
  const {push} = useRouter();
  const title = `${t('YOU_HAVE_18_YEARS')}?`;

  const handleClose = () => {
    push('/');
  };

  return (
    <AlertDialog
      title={title}
      isOpen
      onClose={handleClose}
      onConfirm={onConfirm}
      cancelButtonValue={t('ADULTS_ONLY_CANCEL')}
      successButtonValue={t('ADULTS_ONLY_CONFIRM')}
      closeOnConfirm={false}
    >
      <Text fontWeight={400}>{t('СONTAINS_ADULTS_PRODUCTS')}</Text>
    </AlertDialog>
  );
};
